import _ from 'underscore';
import { MetricPicker } from '@bingads-webui-campaign/overview-metric-picker';
import { DeterministicView, helpers } from '@bingads-webui/deterministic-view';
import template from './template-v2.pug';
import metricPickerButtonTemplate from './metric-picker-button-template.pug';

export default class DeviceMetricView extends DeterministicView {
  constructor(options) {
    super(_.extend({}, options, { renderInSync: true }));
  }

  initialize({
    metricFormatter,
    s$i18n,
    i18n,
    deps,
  }) {
    this.metricFormatter = metricFormatter;
    this.s$i18n = s$i18n;
    this.i18n = i18n;
    this.deps = deps;
  }

  get className() {
    return 'device-metric';
  }

  get template() {
    return template;
  }

  setState({
    metric,
    metrics,
    hideCurrency,
  } = {}) {
    helpers.updateView(helpers.ensureChildView(this, 'metric-picker', MetricPicker, {
      metric,
      metrics,
      buttonTemplate: metricPickerButtonTemplate,
      metricFormatter: this.metricFormatter,
      s$i18n: this.s$i18n,
      i18n: this.i18n,
      deps: this.deps,
    }, {
      pick: ({ metric: picked }) => {
        super.setState({ metric: picked });
        this.trigger('pick', { metric: picked });
      },
    }), {
      metric,
      metrics,
      hideCurrency,
    });

    return super.setState({
      metric,
    });
  }

  renderTrunk() {
    this.$el.html(this.template());
    return this;
  }
}
